import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  CheckupRequestStatusResponse,
  
} from '@companion-professional/dctypes';
import { getActiveCheckups } from '../lib/api';
import { useCheckupItemAnalysis } from './useCheckupItemAnalysis';
import { useClinicId } from '../state/auth';
import { getAnalysisStatusForGait } from './getAnalysisStatusForGait';

// useActiveCheckups is a hook that fetches the active checkups for the currently logged-in user. It returns:
// - isPending: A boolean that indicates if the request is currently in progress.
// - error: An error object if the request failed.
// - checkups: An array of CheckupRequestStatusResponse objects.
export const useActiveCheckups = () => {
  const clinicId = useClinicId();
  const { checkupItemAnalysisResults, isPending: mlResultsPending } = useCheckupItemAnalysis();
  const [checkupsWithAnalysisStatus, setCheckupsWithAnalysisStatus] = useState<CheckupRequestStatusResponse[]>([]);
  const {
    isPending,
    error,
    data: checkups
  } = useQuery<CheckupRequestStatusResponse[]>({
    queryKey: ['active-checkups', clinicId],
    queryFn: () => getActiveCheckups()
  });

  useEffect(() => {
    if (checkups && checkupItemAnalysisResults && !mlResultsPending) {
      setCheckupsWithAnalysisStatus(
        checkups.map((checkup) => ({
          ...checkup,
          analysis_status: getAnalysisStatusForGait(checkupItemAnalysisResults, checkup.id)
        }))
      );
    }
  }, [checkups, checkupItemAnalysisResults, mlResultsPending]);

  return {
    isPending,
    error,
    checkups: checkupsWithAnalysisStatus
  };
};
